import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import authData from "../../services/authData";
import { axiosVal as axios } from "..";

const initialState = {
    loaded: false,
    isLoggedin: false,
    logout: false,
    progress: false,
    deakers: [],
    dealerDetails: {},
    user: {
        
    },
    userAccount: {
        
    },
    searchResults: [],
    accountUpdated: false,
    accountDeleted: false,
    error: {
        status: false,
        message: ""
    },
    success: {
        status: false,
        message: ""
    },
};

const getToken = () => "LiveBearer "+localStorage.getItem('auth-token');

export const getDealers = createAsyncThunk('dealers/get', async() => {
   
    try {
        const response = await axios.get(
            "/dealers/",
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
       
        return response.data;
    }
    catch(error) {
        throw error.response.data;
    }
})

export const getPendingAccounts = createAsyncThunk('dealers/getPendingAccounts', async() => {
   
    try {
        const response = await axios.get(
            "/dealers/getPendingAccounts",
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
       
        return response.data;
    }
    catch(error) {
        throw error.response.data;
    }
})

export const getDealerDetails = createAsyncThunk('dealers/getDealerDetails', async (id) => {
      try {
        const response = await axios.get(
          `/dealers/${id}`, // Use the dynamic `id` in the route
          {
            headers: {
              'x-auth': getToken(), // Attach the token in the headers
            },
          }
        );
        
        return response.data;
      } 
      catch (error) {
        throw error.response?.data || error.message; // Handle error gracefully
      }
});

export const updateDealerDetails = createAsyncThunk(
    'dealers/updateDealerDetails', 
    async ({ dealerId, updatedData }) => {
      try {
        const response = await axios.put(
          `/dealers/${dealerId}`,
          updatedData,
          {
            headers: {
              'x-auth': getToken(),
            },
          }
        );
        return response.data; 
      } catch (error) {
        throw error.response?.data || error.message; 
      }
    }
  );
  

export const pendingAction = createAsyncThunk('dealers/pendingAction', async({dealerId, approved}) => {
   
    try {
        const response = await axios.post(
            "/dealers/pendingAction",
            {
                dealerId,
                approved
            },
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
       
        return response.data;
    }
    catch(error) {
        throw error.response.data;
    }
})

export const deleteDealer = createAsyncThunk(
    "dealers/deleteDealer",
    async (dealerId, { rejectWithValue }) => {
      try {
        await axios.delete(`/dealers/${dealerId}`,
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return dealerId; // Return the deleted dealer ID to update the state
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
);


const dealersSlice = createSlice({
    name: "counter",
    initialState,
    reducers: {
        reset(state, action) {
            state.error.status = false;
            state.success.status = false;
            state.dealerDetails = {}
        },

    },
    extraReducers: (builder) => {

        builder.addCase(getDealers.fulfilled, (state, action) => {
            state.dealers = action?.payload;
        }) 
        builder.addCase(getPendingAccounts.fulfilled, (state, action) => {
            state.pendingAccounts = action?.payload;
        })  
        builder.addCase(pendingAction.fulfilled, (state, action) => {
            state.pendingAccounts = action?.payload;
        })  
        builder.addCase(getDealerDetails.fulfilled, (state, action) => {
            console.log("aaaaaaaaaaaaaaaaaaaaaa ", action?.payload)
            state.dealerDetails = action?.payload;
        })
        builder.addCase(updateDealerDetails.fulfilled, (state, action) => {
            console.log("pxik pxik ", action?.payload)
            state.dealerDetails = action?.payload;
            state.success.status = true;
            state.error.status = false;
            state.success.message = 'Dealer details updated successfully';
        });
        builder.addCase(updateDealerDetails.pending, (state, action) => {
            state.success.status = false;
            state.error.status = false;
        });
        builder.addCase(updateDealerDetails.rejected, (state, action) => {
            state.success.status = false;
            state.error.status = true;
            state.error.message = action.error.message;
        });
        builder
        .addCase(deleteDealer.fulfilled, (state, action) => {
            state.success.status = true;
            state.success.message = "Dealer deleted successfully!";
            state.dealers = state.dealers?.filter(dealer => dealer.id !== action.payload);
            })
        .addCase(deleteDealer.rejected, (state, action) => {
            state.error.status = true;
            state.error.message = action.payload || "Failed to delete dealer.";
        })
    }
});

export const dealersActions = dealersSlice.actions;
export const dealersReducer = dealersSlice.reducer;